<template>
  <v-container fluid class="brand-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn to="/brand/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="brands-table"
              show-select
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="headers"
              :items="[
                ...brands.filter(brand=>brand.brandtype=='Brand'),
                ...brands.filter(brand=>brand.brandtype=='Other Brand'),
              ]"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Brand?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteBrand.brandname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteBrand)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.brandimage" size="35">
                  <img v-bind:src="item.brandimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.brandname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.brandname="{ item }">
                <a class="primaryConst--text">{{ item.brandname }}</a>
              </template>
              <template v-slot:item.brandstatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.brandstatus)"
                  small>
                  {{ item.brandstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from "../../../util/tools";

export default {
  name: 'brandList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deleteBrand: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Type', value: 'brandtype' },
        { text: 'Name', value: 'brandname' },
        { text: 'Code', value: 'brandcode' },
        { text: 'Status', value: 'brandstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      editedIndex: -1,


      getStatusColor: getStatusColor,
    }
  },

  computed: {
    ...mapState('Brand', ['brands', 'isReceiving', 'isDeleting', 'idToDelete', 'brandsMessage', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit brand'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    brandsMessage() {
      this.notification = this.brandsMessage;
      this.addSuccessNotification()
    }
  },
  created () {
    this.getBrandsRequest()
    this.addSuccessNotification()
  },

  methods: {
    ...mapActions('Brand', [
      "getBrandsRequest",
      "deleteBrandRequest",
      "updateBrandRequest",
      "insertBrandRequest"
    ]),

    editItem(item) {
      this.$router.push({ name: 'BrandEdit', params: item })
    },

    deleteItem(item) {

      //const pos = this.brands.map(function(brand) { return brand._id; }).indexOf(item._id);
      //this.brands.splice(pos, 1);
      this.deleteBrandRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteBrand = {
        _id: item._id,
        brandname: item.brandname,
      }
    },
    close () {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        !config.isBackend ?
        Object.assign(this.brands[this.editedIndex], this.editedItem)
        :
        this.updateBrandRequest(this.editedItem)
      } else {
        !config.isBackend ?
        this.brands.push(this.editedItem)
        :
        this.insertBrandRequest(this.editedItem)
      }
      this.close()
    },

    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
